import React, { useEffect } from "react";
import { observer } from "mobx-react";
import { Trans } from "react-i18next";
import { Permissions } from "@whatsper/texterchat-common";
import { useStore } from "../../../../store/rootStore";
import { Operation } from "../../../EntityManager";
import { ManagerListView } from "../core";
import styles from "./LabelsListView.module.scss";
const LabelTeaser = ({ entity }) => {
    return (React.createElement("div", { className: styles.labelItem },
        React.createElement("div", { className: styles.labelColor, style: { backgroundColor: entity.color } }),
        React.createElement("span", { className: styles.labelName }, entity.name)));
};
const LabelsListView = ({ onEntitySelect, onEntityDelete, searchQuery = "", refreshList }) => {
    const { labels, agentsStore } = useStore();
    useEffect(() => {
        refreshList === null || refreshList === void 0 ? void 0 : refreshList(labels.fetchLabels);
    }, [refreshList]);
    const labelsSearchQuery = searchQuery.trim().toLowerCase();
    const getOpSupported = () => {
        const ops = [Operation.LIST];
        if (agentsStore.hasPermissions([Permissions.Permission.labels_manage])) {
            ops.push(Operation.CREATE, Operation.EDIT, Operation.DELETE);
        }
        return ops;
    };
    const sortLabels = (a, b) => {
        return a.name.localeCompare(b.name);
    };
    const filteredLabels = labels.labels.slice().filter((label) => {
        if (!labelsSearchQuery)
            return true;
        return label.name.toLowerCase().includes(labelsSearchQuery);
    });
    return (React.createElement(ManagerListView, { entities: filteredLabels, entityIdKey: "id", teaser: LabelTeaser, loading: labels.loading, opSupported: getOpSupported(), onEntitySelect: onEntitySelect, onEntityDelete: onEntityDelete, createTitle: React.createElement(Trans, { i18nKey: "createLabel" }), sorter: sortLabels }));
};
export default observer(LabelsListView);
